import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import dictionary from '../../../dictionary'
import SelectIcon from '../Icons/SelectIcon'
import isDarkColor from '../../../utils/is-dark-color'
import P from '../Typography/P'

import styles from './color.module.scss'
import LegendsTooltip from './LegendsTooltip'

function MugColor(props) {
  const { content: allContent, current, onChange, name } = props

  const whiteContent = allContent.filter(({ value }) => value.includes(`white`))
  const handleContent = allContent.filter(({ value }) =>
    value.includes(`-handle`)
  )
  const insideContent = allContent.filter(({ value }) =>
    value.includes(`-inside`)
  )

  return [
    { legend: `Белая`, content: whiteContent },
    { legend: `Цветная ручка и ободок`, content: handleContent },
    { legend: `Цветная внутри`, content: insideContent },
  ].map(({ legend, content }) => (
    <div key={legend} className={styles.root}>
      <P size="small" className={styles.legend}>
        {legend}
      </P>
      <div className={styles.content}>
        {content.map(({ label, value, disabled }) => (
          <LegendsTooltip
            key={value}
            title={disabled ? `` : dictionary.item[value]}
          >
            <span className={styles.buttonContainer}>
              <button
                disabled={disabled}
                className={
                  current === value && isDarkColor(label)
                    ? classNames(styles.item, styles.itemInverted)
                    : styles.item
                }
                style={{
                  backgroundColor: label,
                  borderColor: label === `#fbfbfb` ? `#c9cbcc` : `transparent`,
                }}
                onClick={() => onChange(name, value)}
              >
                {current === value && <SelectIcon />}
              </button>
            </span>
          </LegendsTooltip>
        ))}
      </div>
    </div>
  ))
}

MugColor.propTypes = {
  name: PropTypes.string,
  content: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    })
  ),
  current: PropTypes.string,
  onChange: PropTypes.func,
}

export default MugColor
